var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconnn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 703,
    height: 703,
    viewBox: "0 0 703 703",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 703,
    height: 703,
    rx: 351.5,
    fill: "#F93564"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.201 471.01C370.393 472.621 366.292 474.085 361.899 475.55L338.758 483.166C280.614 501.912 250.004 486.241 231.111 428.097L212.365 370.246C193.618 312.102 209.142 281.346 267.286 262.6L289.841 255.13C287.058 262.16 284.715 270.215 282.518 279.296L268.165 340.662C252.055 409.644 275.635 447.723 344.616 464.126L369.221 469.985C370.832 470.424 372.59 470.717 374.201 471.01Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.219 222.763L402.76 217.051C353.843 205.481 324.698 215.001 307.562 250.444C303.169 259.378 299.654 270.216 296.725 282.665L282.372 344.031C268.019 405.25 286.912 435.421 347.985 449.92L372.59 455.778C381.085 457.829 388.993 459.147 396.316 459.733C442.011 464.127 466.323 442.744 478.626 389.872L492.979 328.653C507.332 267.433 488.585 237.116 427.219 222.763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconnn);
export default __webpack_public_path__ + "static/media/profileIconnn.d7f750ee4f1c561d37b1f73a8561c235.svg";
export { ForwardRef as ReactComponent };